import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input
} from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import {
  faMobile,
  faMailBulk,
  faInfo
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ProfileComponent implements OnInit {
  @Input() name: string;
  @Input() mobile: string;
  @Input() email: string;
  @Input() profileLink: string;
  mobileIcon = faMobile;
  mail = faMailBulk;
  info = faInfo;

  constructor(protected ref: NbDialogRef<ProfileComponent>) {}

  dismiss() {
    this.ref.close();
  }

  ngOnInit(): void {}
}
